import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SharedApiService } from './shared-api.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from './api.service';
import apiUrlPoint from '../life-config/apiEndPoints.json';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class SharedDataService {

    proposalRes: any;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    proposalId: any;
    uuid: any;
    count = 0;
    totalQuoteCount = 0; 
    quotesList: any;
    errorQuotesList:any;
    policyMaxAllowed: number;
    incomingApiquotesResponse: any;
    getProposalData: Subject<any> = new Subject();
    getQuoteTermInfo: Subject<any> = new Subject();
    getQuotesLoaderCounter: Subject<any> = new Subject();
    isViewMoreAvail: Subject<any> = new Subject();
    occupationListInfo: Subject<any> = new Subject();
    getLoaderInfo: Subject<any> = new Subject();
    getActivateLoader: Subject<any> = new Subject();
    getDocumentDataOnEvent: Subject<any> = new Subject();
    getProofDocumentData: Subject<any> = new Subject();
    getUploadDocData :Subject<any> = new Subject();
    getSeletcedDocData:Subject<any> = new Subject();
    getSendExpiryData:Subject<any> = new Subject();
    getSendSelectedData:Subject<any> = new Subject();
    clearSelectedData:Subject<any> = new Subject();
    getChangeActivityInfo: Subject<any> = new Subject();
    getDocument: Subject<any> = new Subject();
    getFileInfo: Subject<any> = new Subject();
    isUploadToNextInfo:Subject<any> = new Subject();
    getDropdownDisable: Subject<any> = new Subject();
    apiAvails: boolean;
    selectedDocumentType: number;


    proofDataList: any ;
    occupationList: any;
    docIDInfo: any;
    expiryData: any;
    selectedDocData: any;
    expiryDateInfo: any;
    getRecalculatePremium: Subject<any> = new Subject();
    sendDocumentType: Subject<any> = new Subject();
    updatedPhotoBlockDisplayInfo: Subject<any> = new Subject();
    getAutoPopulateDataInfo: Subject<any> = new Subject();
    getDocumentErrMsg: Subject<any> = new Subject();
    emailComparisonQuote: Subject<any> = new Subject();
    comparisonQuoteObj: Subject<any> = new Subject();
    comparisionPlanQueryParams: Subject<any> = new Subject();
    updatedCompareQueryParams: Subject<any> = new Subject();

    policyList: any = [];

    urlObtained: any;
    proofIndex: any;
    photosToDsiplay: any;
    riderData: any;
    isPicUploaded: any;
    spanProofData: any;
    proofTypeInfo: any;

    stopTimer = false;
    isTotalQuoteFetched = false;
    constructor(
        private sharedApiService: SharedApiService,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private location: Location,
        private router: Router
    ) {

        /**
         * add number dynba,ically when term and saving plan age is being defined
         */
        this.policyMaxAllowed = 85;
        router.events.subscribe((url: any) => this.urlObtained = url);
    }

    /**
     * Seting proposal data so it can be subcribed and called anywhere
     */

    setProposalData(data: any) {
        this.getProposalData.next(data);
    }

    isUploadToNext(data: any){
        this.isUploadToNextInfo.next(data);
    }

    /**
     * Clearing data incoming quotes response
     */

    clearQuotesResponse() {
        this.incomingApiquotesResponse = null;
    }
   

    /**
     * quotes list data
     */

    getQuoteTermData(termPlanObtained,noTermPlanObtained,totalcount) {

        this.getQuoteTermInfo.next({quotesList:termPlanObtained,noQuotesList:noTermPlanObtained,totalQuotes:totalcount});
    }

    /**
     * Quotes loader counter
     */
    setQuotesLoaderCounter(value: number) {

        this.getQuotesLoaderCounter.next(value);
    }




    hideViewMore(boolanValue) {
        this.isViewMoreAvail.next(boolanValue);
    }

    occupationListData(data: any) {

        this.occupationListInfo.next(data);

    }

    getLoaderStatus(data: boolean) {
        this.getLoaderInfo.next(data);
    }

    activateLoaderStatus(data: boolean) {

        this.getActivateLoader.next(data);
    }

    getDocumentInfo(data: any) {
        this.getDocumentDataOnEvent.next(data);
    }

    getDocumentData(data: any) {


        this.getProofDocumentData.next(data);

    }

    /**
     * Invoke function on which data will be reflected if same document id is there
     */

    getDocumentinfo(data: any){

        this.sendDocumentType.next(data);
    }

    getProofTypeDate(data: any){
        this.spanProofData = data;
    }

    photoToDisplay(data:any){

        this.photosToDsiplay = data;
        this.updatedPhotoBlockDisplayInfo.next(data);

    }

    getProofTypeInfo(data: any){

        this.proofTypeInfo = data;
    }


    sendDocumentInfo(data: any) {
        this.getDocument.next(data);
    }

    invokeDocumentData(data: any){
        this.getChangeActivityInfo.next(data);
    }

    getProofDataList(data: any) {
        this.proofDataList = data;
    }

    getIndexofAgeProof(data: any){
        this.proofIndex = data;
    }

    getUploadedDocData(data:any){

        this.getUploadDocData.next(data);
    }


    getFileListInformation(data:any){

        this.getFileInfo.next(data);
    }

    sendSelectedDropdownID(data: any) {
        this.getSeletcedDocData.next(data);
        this.expiryData = data;

    }

    sendExpiryData(data: any) {
        this.getSendExpiryData.next(data);
        this.expiryDateInfo = data;

    }

    sendSelectedDoc(data: any) {
        this.getSendSelectedData.next(data);

        this.docIDInfo = data;
    }

    clearInfo(data: any) {

        this.clearSelectedData.next(data);
    }

    setRiderData(data: any){

        this.riderData = data;
    }

    setDocumnetDropdownDisable(data: any) {
        this.getDropdownDisable.next(data);
    }


    getRecalculatePremiumData(data: boolean) {
        this.getRecalculatePremium.next(data);
    }
    /**
     *
     * Handling chnage event scenario to oveerule change
     */

    getChangeDocInfo(dataObtained, docValue) {
        this.apiAvails = dataObtained;
        this.selectedDocumentType = docValue;
    }

    autoPopulateFinalData(data: any) {
        this.getAutoPopulateDataInfo.next(data);
    }

    setDocumentErrorMsg(data: string) {
        this.getDocumentErrMsg.next(data);
    }

    // quotes comparision email and buy now handling
    invokeEmailComparison(data: any) {
        this.emailComparisonQuote.next(data);
    }

    invokeComparisonQuoteData(data: any, event) {
        this.comparisonQuoteObj.next({data, event});
    }

    // getting compare plan query params
    getComparePlanQueryParams(quoteList: any, paramList: any) {
        this.comparisionPlanQueryParams.next({quoteList, paramList});
    }

    // getting updated compare plan query params after removing all plan from query params
    setUpdatedQueryParams(quoteList: any, paramList: any) {
        this.updatedCompareQueryParams.next({quoteList, paramList});
    }

    /**
     * Get Proposal response  from  shared api service
     * trigger and call this methd from other component
     * and susbcribe  data
     */

    getProposalInfo(proposalId, uuid) {

        this.sharedApiService.getProposalInfo(proposalId, uuid).subscribe(res => {
            if (res) {

                this.proposalRes = res;
                if (this.proposalRes) {
                    this.setProposalData(this.proposalRes);
                }
            }

        });

    }


    /**
     * Initiate quote on every updation so that celery can be  refreshed and feteched new quotes
     * On successful response , get quotation will trigger  which will be triggered on every 5 sec
     * And get quotation life cycle end after 5 min.
     * If anything get updated , then again updaate proposal call will trigger and same cycle repeat
     * update proposal -> initiate_quotation-> get_quotation.
     */


    initiateQuotation(proposalId, uuid) {
        this.errorQuotesList = [];
        this.totalQuoteCount = 0;
        this.quotesList = [];
        this.clearQuotesResponse();
        this.getQuoteTermData(this.quotesList,this.errorQuotesList,this.totalQuoteCount);
        this.getLoaderStatus(false);
        if (this.stopTimer) {
                
            this.invokeQuoteOnInterval(proposalId, uuid);
        } 
        this.apiService.postIntiateQuote(
            this.apiUrl['apiV2LifeProposal'], proposalId, uuid, this.apiUrl['initiate_quotations'], this.apiUrl['extraParams'])
            .subscribe(res => {
                this.stopTimer = false;
                this.invokeQuoteOnInterval(proposalId, uuid);
                this.count = 0;  
            });
    }


    /**
     *  Invoke quote interval after every 5 minutes 
     * 
     */

    invokeQuoteOnInterval = async (proposalId, uuid, count?: string) => {
        if (!this.stopTimer) {
            setTimeout(() => {
                this.getQuoteOnInterval(proposalId, uuid);
            }, 5000);
        }
    }
        /***
        * need to stop calling get quotation on itnerval if res of getQuote will reach at given condition :-
        * {{total == err_quote + quotes}}.
        * 
        */

    checkQuoteStatus(res){
        let items = res['items'].length ? res['items'].length : 0;
        let error_items = res['error_items'].length?res['error_items'].length : 0;
        let total_count_res = res['total']?res['total']:0;
        this.isTotalQuoteFetched = items + error_items == total_count_res;
        this.isTotalQuoteFetched?this.stopTimer=true:this.stopTimer=false;

    }

    /**
     * Thid will trigger on every 5 second interval
     * Wait till successful response and trigger agin
     * Max limit is 2 min
     * after that destroy the cycle
     */
    getQuoteOnInterval(proposalId, uuid, count?: string) {
        this.proposalId = proposalId;
        this.uuid = uuid;
        let quoteDifference;

        this.sharedApiService.getQuote(
            this.proposalId, this.uuid).subscribe(res => {
                if (res) {                  
                    this.checkQuoteStatus(res);
                    this.count++;
                    /**
                     * condition to avoid flickering
                     * and if same quotes
                     */
                if (this.incomingApiquotesResponse){

                        /**
                         * check by filter tag
                         */

                        quoteDifference = Object.entries(this.incomingApiquotesResponse).toString() === Object.entries(res).toString();

                        if (!quoteDifference){

                            this.incomingApiquotesResponse = res;
                            this.getQuoteTermData(this.incomingApiquotesResponse['items'],this.incomingApiquotesResponse['error_items'],this.incomingApiquotesResponse['total']);


                        }
                    } else {

                        this.incomingApiquotesResponse = res;
                        this.getQuoteTermData(this.incomingApiquotesResponse['items'],this.incomingApiquotesResponse['error_items'],this.incomingApiquotesResponse['total']);

                    }
                        if (this.count < 23) {

                            /**
                             * initilaizing loader  until 23 time count
                             */
                            this.invokeQuoteOnInterval(this.proposalId, this.uuid);
                            this.getLoaderStatus(true);
                            /**
                             * getting quotes counter to stop loader
                             */
                            this.setQuotesLoaderCounter(this.count);
    
                        } else {
                            this.count = 0;
                        }
                }

            });
    }


    /**
     * Occcuaption list and subscrive varaible to it
     */

    getOccupationUtilsInfo() {

        // tslint:disable-next-line: max-line-length
        this.apiService.getUtilsWithutInsurerCode(this.apiUrl['getUtilsInfo'], this.apiUrl['occupation']).subscribe(res => {

            this.occupationList = res['occupation'];

            this.occupationListData(this.occupationList);
        });
    }




}
